let taskSources = [
  { value: 1, label: "全部" },
  { value: 2, label: "自定义" },
  { value: 3, label: "科室清单" },
  { value: 4, label: "重大决策部署" },
  { value: 5, label: "指标下发" },
  { value: 6, label: "任务池" },
]
let taskAcceptTable = [
  { label: "序号", prop: "taskId", sortable: 1 },
  { label: "任务分类", prop: "categoryName" },
  { label: "工作内容", prop: "detail" },
  { label: "标准要求", prop: "evaCriterion" },
  { label: "任务类型", prop: "taskType" },
  { label: "要求完成时限", prop: "dateLimit" },
  { label: "备注", prop: "remarks" },
  { label: "是否完成", prop: "accomplish" },
  { label: "完成时间", prop: "accomplishDate" },
  { label: "是否接受", prop: "accept" },
]

export {
  taskSources,
  taskAcceptTable
}